import { _ as __awaiter, a as __generator } from './tslib.es6-e24bb3a5.js';
import { extend } from 'umi-request';
import uuid from './uuid.js';

var _a;
var request = extend({
  timeout: 30 * 1000
});
var QiniuBucket;

(function (QiniuBucket) {
  QiniuBucket["default"] = "sunzi_ai";
})(QiniuBucket || (QiniuBucket = {}));

var QiniuHost = (_a = {}, _a[QiniuBucket.default] = {
  upload: 'https://upload-na0.qiniup.com',
  prefix: 'https://sunzi7n.imaiyuan.com/'
}, _a);

var Qiniu = function () {
  function Qiniu() {
    var _this_1 = this;

    this._retryCount = 0;
    this._bucket = QiniuBucket.default;
    this._queue = Promise.resolve();

    this.prefix = function (prefix) {
      _this_1._queue = _this_1._queue.then(function () {
        _this_1._prefix = prefix;
      });
      return _this_1;
    };

    this.bucket = function (bucket) {
      if (bucket === void 0) {
        bucket = QiniuBucket.default;
      }

      _this_1._queue = _this_1._queue.then(function () {
        _this_1._bucket = bucket;
      });
      return _this_1;
    };

    this.timeout = function (timeout) {
      _this_1._queue = _this_1._queue.then(function () {
        _this_1._timeout = timeout;
      });
      return _this_1;
    };

    this.retryCount = function (count) {
      _this_1._queue = _this_1._queue.then(function () {
        _this_1._retryCount = count;
      });
      return _this_1;
    };

    this.onprogress = function (onprogress) {
      _this_1._queue = _this_1._queue.then(function () {
        _this_1._onprogress = onprogress;
      });
      return _this_1;
    };

    this._getToken = function () {
      return __awaiter(_this_1, void 0, void 0, function () {
        var _a, token, _b, expireTime, response;

        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              _a = JSON.parse(localStorage.getItem('_qiniu_token') || '[]'), token = _a[0], _b = _a[1], expireTime = _b === void 0 ? 0 : _b;
              if (!(token && expireTime - new Date().getTime() > 60 * 1000)) return [3, 1];
              return [2, token];

            case 1:
              return [4, request('https://sunzi.stylelab.com/qiniu/token/bucket', {
                method: 'get',
                params: {
                  bucket: this._bucket
                }
              })];

            case 2:
              response = _c.sent();

              if (response.error === 0) {
                localStorage.setItem('_qiniu_token', JSON.stringify([response.token, response.expire * 1000]));
                return [2, response.token];
              }

              return [2, undefined];
          }
        });
      });
    };

    this._upload = function (file, key, onprogress) {
      return new Promise(function (resolve, reject) {
        var xhr = new XMLHttpRequest();

        xhr.upload.onprogress = function (e) {
          if (e.total > 0) onprogress(Math.min(99, e.loaded / e.total * 100));
        };

        var formData = new FormData();
        formData.append('file', file);
        formData.append('token', _this_1._token);
        formData.append('key', key);
        if (_this_1._timeout) xhr.timeout = _this_1._timeout * 1000;

        xhr.onload = function () {
          if (xhr.status < 200 || xhr.status >= 300) reject();else {
            var response = xhr.responseText || xhr.response;

            try {
              onprogress(100);
              var key_1 = JSON.parse(response).key;
              return resolve(QiniuHost[_this_1._bucket].prefix + key_1);
            } catch (e) {
              reject();
            }
          }
        };

        xhr.onerror = reject;
        xhr.ontimeout = reject;
        xhr.open('post', QiniuHost[_this_1._bucket].upload, true);
        xhr.send(formData);
      });
    };

    this._dateTime = function () {
      return "" + new Date().getFullYear() + (new Date().getMonth() + 1) + new Date().getDate();
    };

    this.upload = function (blob) {
      return _this_1._queue.then(function () {
        return __awaiter(_this_1, void 0, void 0, function () {
          var _a, path, blobs, percents, retryCounts, _onprogress, data;

          var _this_1 = this;

          return __generator(this, function (_b) {
            switch (_b.label) {
              case 0:
                _a = this;
                return [4, this._getToken()];

              case 1:
                _a._token = _b.sent();
                path = this._prefix + "/" + this._dateTime() + "/" + uuid();
                blobs = blob instanceof Array ? blob : [blob];
                percents = [], retryCounts = Array.from({
                  length: blobs.length
                }).map(function (_) {
                  return 0;
                });

                _onprogress = function (index) {
                  return function (percent) {
                    if (_this_1._onprogress) {
                      percents[index] = Math.max(percent, percents[index] || 0);

                      _this_1._onprogress(percents.reduce(function (a, b) {
                        return a + b;
                      }) / blobs.length);
                    }
                  };
                };

                return [4, Promise.all(blobs.map(function (_, index) {
                  return new Promise(function (resolve) {
                    var blob = blobs[index];
                    var format = blob.type.split('/')[1] || 'png';
                    var _this = _this_1;

                    (function _upload() {
                      return _this._upload(blob, path + "-" + index + "." + format, _onprogress(index)).then(resolve).catch(function () {
                        if (retryCounts[index] < _this._retryCount) {
                          retryCounts[index]++;

                          _upload();
                        } else {
                          resolve(undefined);
                        }
                      });
                    })();
                  });
                }))];

              case 2:
                data = _b.sent();
                return [2, {
                  status: data.indexOf(undefined) === -1,
                  data: data.filter(function (item) {
                    return !!item;
                  })
                }];
            }
          });
        });
      });
    };
  }

  Qiniu.thumbnail = function (URL, size) {
    return URL + "?imageMogr2/thumbnail/" + [size.width || '', 'x', size.height || ''].join('') + "|imageslim";
  };

  Qiniu.crop = function (URL, crop) {
    return URL + "?imageMogr2/crop/!" + crop[2] + "x" + crop[3] + "a" + crop[0] + "a" + crop[1] + "|imageslim";
  };

  Qiniu.imageslim = function (URL) {
    return URL + "?imageslim";
  };

  Qiniu.format = function (URL, format) {
    return URL + "?imageMogr2/format/" + format + "|imageslim";
  };

  Qiniu.quality = function (URL, quality) {
    return URL + "?imageMogr2/quality/" + quality + "|imageslim";
  };

  return Qiniu;
}();

export default Qiniu;
export { QiniuBucket };
